import { render, staticRenderFns } from "./truck-summary-modal.vue?vue&type=template&id=70f32118&scoped=true&"
import script from "./truck-summary-modal.component.ts?vue&type=script&lang=ts&"
export * from "./truck-summary-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./truck-summary-modal.scss?vue&type=style&index=0&id=70f32118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f32118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f32118')) {
      api.createRecord('70f32118', component.options)
    } else {
      api.reload('70f32118', component.options)
    }
    module.hot.accept("./truck-summary-modal.vue?vue&type=template&id=70f32118&scoped=true&", function () {
      api.rerender('70f32118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery/components/truck-summary-modal/truck-summary-modal.vue"
export default component.exports